import React from 'react'
import PropTypes from 'prop-types'
import {
  REACT_APP_CENTROAYUDA_URL,
  REACT_APP_MP_API_URL,
  REACT_APP_CONDITIONS_URL,
  REACT_APP_RRSS_FACEBOOK,
  REACT_APP_RRSS_TWITTER,
  REACT_APP_RRSS_LINKEDIN,
  REACT_APP_RRSS_YOUTUBE
} from '../../config/settings/environment'
import {
  Content,
  FacebookIcon,
  GridContainer,
  GridItem,
  Item,
  Link,
  LinkedInIcon,
  List,
  Logo,
  Root,
  Strong,
  TwitterIcon,
  YouTubeIcon
} from './Footer.styles'

/**
 * The Footer's container.
 */
const Footer = props => {
  const { margin } = props

  return (
    <Root margin={margin}>
      <Content>
        <GridContainer>
          <GridItem md={2} sm={12} xs={12}>
            <Logo src="/assets/images/logo-dccp-oscuro.svg" />
          </GridItem>
          <GridItem md={3} sm={6} xs={12}>
            <List>
              <Item>
                <Strong>Dirección ChileCompra</Strong>
              </Item>
              <Item>Ministerio de Hacienda, Gobierno de Chile</Item>
              <Item>Monjitas 392 - Piso 8, Santiago de Chile.</Item>
              <Item>
                <Link href={REACT_APP_CONDITIONS_URL}>Términos y condiciones</Link>
              </Item>
            </List>
          </GridItem>
          <GridItem md={2} sm={6} xs={12}>
            <List>
              <Item>
                <Strong>Sitios Relacionados</Strong>
              </Item>
              <Item>
                <Link href={REACT_APP_MP_API_URL}>API Mercado Público</Link>
              </Item>
            </List>
          </GridItem>
          <GridItem md={2} sm={6} xs={12}>
            <List>
              <Item>
                <Strong>Mesa de ayuda</Strong>
              </Item>
              <Item>
                <Link href="tel:+6000061211">600 0061 211</Link>
              </Item>
              <Item>
                <Link href="tel:+56225950820">+56 2 2595 0820</Link>
              </Item>
              <Item>
                <Link href={REACT_APP_CENTROAYUDA_URL}>Contacto</Link>
              </Item>
            </List>
          </GridItem>
          <GridItem md={3} sm={6} xs={12}>
            <List>
              <Item>
                <Strong>Síguenos en</Strong>
              </Item>
              <Item className="rrss-container">
                <Link href={REACT_APP_RRSS_FACEBOOK}>
                  <FacebookIcon />
                </Link>
                <Link href={REACT_APP_RRSS_TWITTER}>
                  <TwitterIcon />
                </Link>
                <Link href={REACT_APP_RRSS_LINKEDIN}>
                  <LinkedInIcon />
                </Link>
                <Link href={REACT_APP_RRSS_YOUTUBE}>
                  <YouTubeIcon />
                </Link>
              </Item>
            </List>
          </GridItem>
        </GridContainer>
      </Content>
    </Root>
  )
}

Footer.defaultProps = {
  margin: '96px 0 0'
}

Footer.propTypes = {
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default Footer
